import type { CollaboratorAccrualsRepositoryT } from "../../domain/ports/collaboratorAccruals.repository";
import type { UpdateAccrualInputT } from "../../domain/types/collaboratorAccruals.types";

type UpdateCollaboratorAccrualsParamsT = {
  accruals: UpdateAccrualInputT[];
  colaboraInstanceId: string;
  collaboratorAccrualsRepository: CollaboratorAccrualsRepositoryT;
};

export const updateCollaboratorAccruals = async ({
  accruals,
  colaboraInstanceId,
  collaboratorAccrualsRepository,
}: UpdateCollaboratorAccrualsParamsT) =>
  collaboratorAccrualsRepository.update(accruals, colaboraInstanceId);
